module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authorizeUserAdd"
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "arrow-left",
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.opertionType !== 'add') ? [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.opertionType === 'edit',
      "icon": "edit"
    },
    on: {
      "click": _vm.toEditPage
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.opertionType === 'edit',
      "icon": "delete"
    },
    on: {
      "click": _vm.deleteInfo
    }
  }, [_vm._v("删除")])] : _vm._e()], 2), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "用户管理",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userData,
      "rules": _vm.rules,
      "label-width": "105px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 20,
      "sm": 18,
      "md": 15,
      "lg": 13
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户AppID",
      "prop": "AppID"
    }
  }, [(_vm.opertionType !== 'add') ? _c('span', [_vm._v(_vm._s(_vm.userData.AppID))]) : _c('el-input', {
    attrs: {
      "maxlength": 50,
      "size": "small"
    },
    model: {
      value: (_vm.userData.AppID),
      callback: function($$v) {
        _vm.$set(_vm.userData, "AppID", $$v)
      },
      expression: "userData.AppID"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btnKey",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.generateID
    }
  }, [_vm._v("生成ID")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户AppKey",
      "prop": "AppKey"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opertionType === 'detail'),
      expression: "opertionType === 'detail'"
    }]
  }, [_vm._v(_vm._s(_vm.userData.AppKey))]), _vm._v(" "), (_vm.opertionType !== 'detail') ? [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.AppKey),
      callback: function($$v) {
        _vm.$set(_vm.userData, "AppKey", $$v)
      },
      expression: "userData.AppKey"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btnKey",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.generateKey
    }
  }, [_vm._v("生成key")])] : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.tips))]), _vm._v(" "), _c('i', {
    staticClass: "egofont ego-copy_b",
    attrs: {
      "id": "AppKeyContent"
    },
    on: {
      "mouseenter": _vm.changeTips
    }
  })])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名称",
      "prop": "AppCustName"
    }
  }, [(_vm.opertionType === 'detail') ? _c('span', [_vm._v(_vm._s(_vm.userData.AppCustName))]) : _c('el-input', {
    attrs: {
      "maxlength": 30,
      "size": "small"
    },
    model: {
      value: (_vm.userData.AppCustName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "AppCustName", $$v)
      },
      expression: "userData.AppCustName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权有效期",
      "prop": "AppExpireDate"
    }
  }, [(_vm.opertionType === 'detail') ? _c('span', [_vm._v(_vm._s(_vm._f("excludeTime")(_vm.userData.AppExpireDate)))]) : _c('el-date-picker', {
    attrs: {
      "type": "date",
      "size": "small",
      "clearable": false,
      "editable": false,
      "picker-options": _vm.pickerOptions0
    },
    on: {
      "change": _vm.settime
    },
    model: {
      value: (_vm.effectDate),
      callback: function($$v) {
        _vm.effectDate = $$v
      },
      expression: "effectDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户状态",
      "prop": "Tag"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.opertionType === 'detail'
    },
    model: {
      value: (_vm.userData.Tag),
      callback: function($$v) {
        _vm.$set(_vm.userData, "Tag", $$v)
      },
      expression: "userData.Tag"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "Memo"
    }
  }, [(_vm.opertionType === 'detail') ? _c('span', [_vm._v(_vm._s(_vm.userData.Memo))]) : _c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": 120,
      "rows": 6
    },
    model: {
      value: (_vm.userData.Memo),
      callback: function($$v) {
        _vm.$set(_vm.userData, "Memo", $$v)
      },
      expression: "userData.Memo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.opertionType !== 'detail') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAddInfo
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.opertionType === 'edit') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "权限设置",
      "name": "second",
      "disabled": _vm.opertionType === 'add'
    }
  }, [_c('show-table', {
    ref: "showtable",
    attrs: {
      "queryobj": _vm.queryObj,
      "queryparam": _vm.queryParam,
      "showopertbtn": _vm.showType
    },
    on: {
      "delItem": _vm.delAuthorize
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "add",
      "type": "primary",
      "icon": "plus",
      "size": "small"
    },
    on: {
      "click": _vm.addAuthorize
    },
    slot: "add"
  }, [_vm._v("增加权限")])], 1)], 1)], 1), _vm._v(" "), _c('queryuser', {
    ref: "queryuserDialog",
    attrs: {
      "appid": _vm.rowDatas.AppID,
      "dialog-table-visible": _vm.dialogTableVisible
    },
    on: {
      "passtabledata": _vm.passTableData,
      "update:dialogTableVisible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-baf2837c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/00399302/authorizeUserAdd.vue
// module id = FzFV
// module chunks = 1